<template>
    <div :id="ID()" :class="['btn detail-button flex-center m-no-margin-l m-no-pad m-row', classes.state]" @click="Select()" @mouseenter="Hover(true)" @mouseleave="Hover(false)">
        <div class="detail-label flex-y-center m-flex-y-center">
            <img :src="icon" width="40" height="40" :alt="`Icon - ${button.Name}`" :title="button.Name"/>
            <span class="name">{{ button.Name }}</span>
        </div>
        <img class="expand-indicator" :src="expandIndicatorSource" alt="Icon - Plus" title="Plus" width="30" height="30" v-if="mobile"/>
        <slot v-if="mobile"/>
    </div>
</template>

<script>
import { Animation } from "@/assets/JS/Animation.js";
import $ from "jquery";

export default {
    name: "ProjectDetailButton",
    props: {
        index: Number,
        button: Object,
        active: Boolean,
        mobile: Boolean
    },
    data: () => ({
        icon: "",
        classes: { state: "" },
        hovering: false,
        expandIndicatorSource: ""
    }),
    methods: {
        SetState: function(active) {
            const { Active, Inactive } = this.button.IconSources;
            const iconSource = active ? Active : Inactive;
            this.icon = require(`@/assets/Images/${iconSource}`);
            this.classes.state = active ? "detail-button-active" : "detail-button-inactive";
        },
        Hover: function(over) {
            if (!this.mobile) {
                this.hovering = over;
                this.SetState(over);
            }
        },
        ExpandIndicatorSource: function() {
            const expandIndicatorSource = !this.active ? "PlusBlue.png" : "MinusBlue.png";
            this.expandIndicatorSource = require(`@/assets/Images/${expandIndicatorSource}`);
        },
        Select: function() {
            this.$emit("select", this.button.Name);
            if (this.mobile) {
                this.ExpandIndicatorSource();

                // Delay scroll-to animation as to wait for the content of each item to display
                const scrollDelay = 300;
                const component = this;
                window.setTimeout(function() {
                    new Animation(
                        $("html"),
                        "Scroll Top",
                        $(`#${component.ID()}`).offset().top,
                        scrollDelay,
                        0
                    );
                }, scrollDelay);

            }
        },
        ID: function() {
            const id = `detail-button-${this.index + 1}`;
            return !this.mobile ? id : `m-${id}`;
        }
    },
    beforeMount: function() {
        this.SetState(this.active);
        this.ExpandIndicatorSource();
    },
    updated: function() {
        if (!this.hovering) {
            this.SetState(this.active);
        }
        if (this.mobile) {
            this.ExpandIndicatorSource();
        }
    },
    emits: [ "select" ]
};
</script>